import { defineMessages } from "react-intl";

/** Section-level strings: page titles the views own, and the delete dialogs. */
export const sectionMessages = defineMessages({
  sectionTitle: {
    id: 'ZHHCNS',
    defaultMessage: "Bundles & Kits",
    description: "kits section, title and sidebar entry",
  },
  discountFixed: {
    id: 'S+mVFx',
    defaultMessage: "Fixed amount",
    description: "kit discount kind",
  },
  discountPercent: {
    id: 'UTPQ+U',
    defaultMessage: "Percentage",
    description: "kit discount kind",
  },
  createKitTitle: {
    id: 'zo9wJ8',
    defaultMessage: "Create kit",
    description: "kit create, page title",
  },
  collection: {
    id: 'ur3X04',
    defaultMessage: "Collection",
    description: "collection picker label",
  },
  collectionHelp: {
    id: 'TfypH1',
    defaultMessage: "The collection sold as a kit",
    description: "collection picker help",
  },
  kitDeleteTitle: {
    id: 'MikllT',
    defaultMessage: "Delete kit",
    description: "kit detail, dialog title",
  },
  kitDeleteContent: {
    id: '29UGJq',
    defaultMessage:
      "Stop selling {name} as a kit? The collection and its products are left alone.",
    description: "kit detail, dialog content",
  },
});

/** Live or Draft on the kit list. */
export const statusMessages = defineMessages({
  live: {
    id: 'YT7uWg',
    defaultMessage: "Live",
    description: "kit list status pill",
  },
  draft: {
    id: 'KPtuo3',
    defaultMessage: "Draft",
    description: "kit list status pill",
  },
});
